var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "system-user" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        staticClass: "table-wrap"
      },
      [
        _c(
          "vxe-table",
          {
            attrs: {
              align: "center",
              data: _vm.tabelData,
              "column-config": _vm.columnConfig,
              "show-overflow": "",
              "row-config": { isHover: true, height: 55 },
              size: "small"
            }
          },
          [
            _c("vxe-column", {
              attrs: { field: "User_Name", width: "", title: "登录账号" }
            }),
            _c("vxe-column", {
              attrs: { field: "Nick_Name", width: "", title: "用户名称" }
            }),
            _c("vxe-column", { attrs: { field: "Mobile", title: "手机号码" } }),
            _c("vxe-column", {
              attrs: { field: "Email", width: "", title: "邮箱" }
            }),
            _c("vxe-column", {
              attrs: { field: "Role_Name", width: "", title: "所属角色" }
            }),
            _c("vxe-column", {
              attrs: { field: "filterENABLED", width: "", title: "是否激活" }
            }),
            _c(
              "vxe-column",
              { attrs: { field: "", width: "", title: "操作" } },
              [
                [
                  _c("div", { staticClass: "operation-wrap" }, [
                    _c("span", [_vm._v("查看")]),
                    _c("span", [_vm._v("编辑")]),
                    _c("span", [_vm._v("删除")])
                  ])
                ]
              ],
              2
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }